import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import LoginPanel from '../login';
import { urlQuery } from '@ug/utils';
import { getModuleAuths } from '@/services/login';
import { MODULE_MAP } from '@ug/constants';
import { DEFAULT_URL } from '@/constants/common';

const mapState = (state: any) => {
  const { userInfo } = state.common;
  return { userInfo };
};
const mapDispatch = (dispatch: any) => {
  const { getUserInfo } = dispatch.common;
  return { getUserInfo };
};

const Main = (props: any) => {
  useEffect(() => {
    handleCheckUserInfo();
  }, []);

  const handleCheckUserInfo = async () => {
    const rst = await props.getUserInfo();
    const from = urlQuery('from');

    if (rst?.login) {
      if (from === 'game') {
        window.location.href = `/${DEFAULT_URL.game}`;
        return;
      }

      const auths = await getModuleAuths();
      const firstCenter: string = Object.keys(auths)[0] || MODULE_MAP.DAYU_MATERIAL.value;
      window.location.href = `/${MODULE_MAP[firstCenter]?.path || DEFAULT_URL.material}`;
    }
  };

  if (!props.userInfo) {
    return <LoginPanel />;
  }

  return <div />;
};

export default connect(mapState, mapDispatch)(Main);
